import { render, staticRenderFns } from "./StudiosGridView.vue?vue&type=template&id=b5ba9600&scoped=true"
import script from "./StudiosGridView.vue?vue&type=script&setup=true&lang=ts"
export * from "./StudiosGridView.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./StudiosGridView.vue?vue&type=style&index=0&id=b5ba9600&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5ba9600",
  null
  
)

export default component.exports